import React from 'react';
import navigationMethods from '../../../utils/navigationUtils';

interface ITrackerIcon {
  trackerIcon: string;
  trackerLink?: number | string;
}

const TrackerIcon: React.FC<ITrackerIcon> = ({ trackerIcon, trackerLink }) => {
  return (
    <img
      alt={`icon-${trackerIcon}`}
      src={navigationMethods.getSystemImageUrl(`${trackerIcon}.svg`)}
      width={'35.78px'}
      height={'35.78px'}
      style={{ cursor: 'pointer' }}
      onClick={() => {
        if (trackerLink) {
          navigationMethods.navigate('/tracking/' + trackerLink);
        }
      }}
    />
  );
};

export default TrackerIcon;
